export default __webpack_public_path__ + "static/without_product_repeat_order-baf0a702e3a3825b666740870fd5ff05.png";